import { AxiosError } from 'axios';
import { produce } from 'immer';

import LoadingStatus from '@libs/loading-status';

import {
  REQUESTER_LINK__FETCH_FAILURE,
  REQUESTER_LINK__FETCH_REQUEST,
  REQUESTER_LINK__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { RequesterLinkAction } from '@app/store/requesterLink/actions';

export interface RequesterLinkState {
  status: LoadingStatus;
  error: AxiosError | null;
}

const initialState: RequesterLinkState = {
  status: LoadingStatus.IDLE,
  error: null,
};

function reducer(state: RequesterLinkState = initialState, action: RequesterLinkAction) {
  switch (action.type) {
    case REQUESTER_LINK__FETCH_REQUEST:
      return produce(state, (draft) => {
        draft.status = LoadingStatus.PENDING;
      });
    case REQUESTER_LINK__FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.status = LoadingStatus.SUCCEEDED;
      });
    case REQUESTER_LINK__FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.status = LoadingStatus.FAILED;
        draft.error = action.payload;
      });
    default:
      return state;
  }
}

export default reducer;
